<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-card>
            <v-toolbar card color="white">
              <v-toolbar-title>
                <h3>Change Password</h3>
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          
            <v-divider></v-divider>

            <v-card-text class="pa-0">
             <v-form @submit.prevent="submit()" autocomplete="off">
                <input autocomplete="false" name="hidden" type="text" style="display:none;">
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex lg12 md12 xs12>
                      <v-text-field :type="'password'"
                        label="Current Password *"
                        class="white-placeholder"
                        autocomplete="off"
                        v-model="form.current_password"
                        id="current_password"
                        data-vv-name="current_password"
                        data-vv-as="Current Password"
                        placeholder
                        v-validate="{required:true}"
                        :error-messages="errors.collect('current_password')"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg12 md12 xs12>
                      <v-text-field :type="'password'"
                        label="New Password *"
                        class="white-placeholder"
                        autocomplete="off"
                        v-model="form.new_password"
                        id="new_password"
                        data-vv-name="new_password"
                        data-vv-as="New Password"
                        placeholder
                        v-validate="{'required':true,'min':8,'restrictedWord':[]}" ref="new_password"
                        :error-messages="errors.collect('new_password')"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex lg12 md12 xs12>
                      <v-text-field
                      label="Confirm New Password *"
                      data-vv-name="password_confirmation"
                      data-vv-as="Confirm New Password"
                      data-vv-delay="300"
                      v-validate="'required|confirmed:new_password'"
                      v-model="form.confirm_new_password"
                      :error-messages="errors.collect('password_confirmation')"
                      :type="'password'"
                    ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex lg12 md12>
                      <div class="form-btn text-xs-right">
                        <v-btn type="submit" color="green white--text">Submit</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../services/HttpService";
export default {
  components:{
    GoogleAds
  },
  data: () => ({
    form: {
      current_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  }),
  methods: {
    ...mapActions([
    ]),
    _showToast(msg, color) {
      window.getApp.$emit("showSnackbar", {
        color,
        msg
      });
    },
    submit() {
      const self = this,
        wApp = window.getApp;
      self.$validator
        .validateAll()
        .then(isValid => {
          // Data is valid, so we can change password
          if (isValid) {
            wApp.$emit("showLoader", {
              show: true
            });
            services
              .post("users/changeUserPassword", {
                password: self.form.new_password,
                old_password: self.form.current_password
              },{"Authorization": "Bearer " + self.$store.state.user.token})
              .then(res => {
                wApp.$emit("showLoader", {
                  show: false
                });
                if (res.data.status) {
                  self.form.current_password = "";
                  self.form.new_password = "";
                  self.form.confirm_new_password = "";
                  self.$validator.reset();
                  self._showToast(res.data.message);
                } else {
                  self._showToast(res.data.message, "red");
                }
              })
              .catch(err => {
                self._showToast(err.message, "red");
              });
          }
        })
        .catch(e => {
          wApp.$emit("showLoader", {
            show: false
          });
          return false;
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.payment-method {
  border: 1px solid #eee;
}

.link-btn {
  box-shadow: none !important;
}

:-ms-input-placeholder { /* IE 10+ */
  color: green;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue